<ais-instantsearch *ngIf="alogliaConfig" [config]="alogliaConfig">
  <ais-configure [searchParameters]="searchParameters"></ais-configure>
  <ng-template #searchInputBox>
    <ais-search-box
      placeholder="Search Anything"
      [searchAsYouType]="false"
      [autofocus]="false"
    >
    </ais-search-box>
  </ng-template>
  <ng-template #mobileTabletFixedHeader>
    <div class="four-wide column">
      <div class="ui left aligned basic fitted segment">
        <button class="ui primary icon button">
          <i class="arrow left icon"></i>
        </button>
      </div>
    </div>
    <div class="eight-wide column">
      <div class="ui center aligned basic fitted segment">Search Screens</div>
    </div>
    <div class="four-wide column">
      <div class="ui right aligned basic fitted segment">
        <button class="ui primary icon button" (click)="isShowFilter()">
          <i class="filter icon"></i>
        </button>
      </div>
    </div>
    <div class="sixteen-wide column">
      <ng-container *ngTemplateOutlet="searchInputBox"></ng-container>
    </div>
  </ng-template>

  <div class="ui fluid listings-card-container container">
    <div class="ui basic padded pd-0-xs segment">
      <div class="ui basic horizontally fixed-top-header fitted segment">
        <ng-container *ngIf="this.facetCategory">
          <div class="ui basic fitted horizontally segment">
            <span class="ui text">
              Showing results for {{ this.facetCategory }}
            </span>
            <a class="ui label" [routerLink]="['/listings']">
              {{ this.facetValue }} <i class="icon close"></i>
            </a>
          </div>
        </ng-container>
        <div class="ui mobile-only mt-0 middle aligned grid">
          <ng-container
            *ngTemplateOutlet="mobileTabletFixedHeader"
          ></ng-container>
        </div>
        <div class="ui tablet-only mt-0 middle aligned grid">
          <ng-container
            *ngTemplateOutlet="mobileTabletFixedHeader"
          ></ng-container>
        </div>
        <div
          class="
            ui
            secondary
            no
            border
            segment
            pure-hidden-xs pure-hidden-sm pure-hidden-md
          "
        >
          <div class="ui middle aligned grid">
            <div class="stretched row">
              <div class="thirteen-wide computer-only column">
                <ng-container *ngTemplateOutlet="searchInputBox"></ng-container>
              </div>
              <div class="one-wide computer-only column">
                <button class="ui basic fluid big icon button disabled">
                  <i class="list ul icon"></i>
                </button>
              </div>
              <div class="one-wide computer-only column">
                <div class="ui slider checkbox">
                  <input
                    type="checkbox"
                    (change)="updateStatusById($event.target.checked)"
                    #isChecked
                    name="newsletter"
                  />
                  <label>Map</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [hidden]="!isChecked.checked">
          <signgaze-map-view></signgaze-map-view>
        </div>
      </div>

      <div [hidden]="isChecked.checked">
        <signgaze-card-view></signgaze-card-view>
      </div>
    </div>
  </div>
</ais-instantsearch>
